<!--
 * @Author: LHB
 * @Date: 2022-06-08 22:04:13
 * @LastEditTime: 2022-07-23 10:53:18
 * @LastEditors: LHB
 * @Description: 
 * @FilePath: \shirleyClass\src\modules\Login\index.vue
 * ---
-->

<template>
  <div class="wrap">
    <!-- 登录页-start -->
    <div class="hedaer">
      <img
        class="logo"
        src="../../assets/images/logo_login_photo@2x.png"
        alt=""
      />
    </div>
    <div class="content">
      <!-- 手机号登录-start -->
      <div v-if="loginType == 1" class="box-input box-phone">
        <div>
          <p class="login-title">
            您好，<br />
            请输入购课手机号登录！
          </p>
          <div class="moblieWrap">
            <div class="inputItem">
              <div class="input-left">手机号：</div>
              <div class="input-right">
                <input
                  class="mobileInput"
                  type="tel"
                  v-model="tel"
                  :maxlength="11"
                  placeholder="请输入课程手机号"
                />
              </div>
            </div>
            <div class="inputItem">
              <div class="input-left">验证码：</div>
              <div class="input-right">
                <input
                  class="mobileInput"
                  type="tel"
                  v-model="verCode"
                  :maxlength="6"
                  placeholder="请输入验证码"
                />
              </div>
              <div class="code-right">
                <!-- <div class="verBtn" @click="isCount ? '' : getCode()"> -->
                <div class="verBtn" @click="getCode">
                  {{ codeText }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 手机号登录-end -->
      <!-- 密码登录-start -->
      <div v-else class="box-input box-phone">
        <div>
          <p class="login-title">
            您好，<br />
            请输入密码登录！
          </p>
          <div class="moblieWrap">
            <div class="inputItem">
              <div class="input-left">手机号：</div>
              <div class="input-right">
                <input
                  class="mobileInput"
                  type="tel"
                  v-model="tel"
                  :maxlength="11"
                  placeholder="请输入课程手机号"
                />
              </div>
            </div>
            <div class="inputItem">
              <div class="input-left input-password">密码：</div>
              <div class="input-right">
                <input
                  class="mobileInput"
                  :type="isShowPassWord ? '' : 'password'"
                  v-model="password"
                  :maxlength="20"
                  placeholder="请输入密码"
                />
              </div>
              <div class="code-right password-right" @click="displayPassword">
                <img
                  v-if="!isShowPassWord"
                  class="passwod-icon"
                  src="../../assets/images/password_close_icon@2x.png"
                  alt=""
                />
                <img
                  v-else
                  class="passwod-icon"
                  src="../../assets/images/password_open_icon@2x.png"
                  alt=""
                />
              </div>
            </div>
            <div class="forget-btn">
              <span @click="forgetBtn" class="forget-btnText">忘记密码</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 密码登录-end -->

      <van-button
        class="loginBtn"
        :class="loginType == 0 ? 'passWordBtn' : ''"
        :loading="loginLoading"
        :loading-text="loadingText"
        @click="submit"
        >登录</van-button
      >
      <span class="login-type" @click="swtchLogin">{{
        loginType == 1 ? '密码登录' : '验证码登录'
      }}</span>
    </div>
    <!-- 登录页-end -->
  </div>
</template>
<script>
import group from '../common/group'
import utils from '../../utils/index.js'
import tools from '../common/tools.js'
import wx_tools from '../common/wx_tools.js'
import urls from '../../utils/urls'
import { json } from 'body-parser'
export default {
  name: 'login',
  components: {},
  data() {
    return {
      loginType: 1, //1 验证码登录 0 密码登录
      tel: '',
      verCode: '',
      password: '',
      codeText: '获取验证码',
      isCount: false, //正在倒计时时不能点击
      codeTimer: '',
      loginLoading: false,
      loadingText: '登录中',
      token: '',
      phone: '',
      user: {},
      userKey: 'userKey',
      tokenKey: 'tokenKey',
      phoneKey: 'phoneKey',
      orginUrlKey: 'orginUrlKey',
      wxThirdid: '',
      wxThirdidKey: 'wxThirdidKey',
      isShowPassWord: false
    }
  },
  mounted() {
    document.title = '登录'

    this.phone = localStorage.getItem(this.phoneKey)
    this.wxThirdid = localStorage.getItem(this.wxThirdidKey)
    console.log(
      'login-moutend',
      this.phone,
      this.wxThirdid,
      localStorage.getItem('logout')
    )

    // 测试-start
    // this.phone = ''
    // this.wxThirdid = '132813056040304640'
    // console.log('wxThirdid', this.wxThirdid)
    // localStorage.setItem(this.wxThirdidKey, this.wxThirdid)
    // 测试-end

    // return

    // 有手机号，直接跳转课程首页
    if (this.phone && this.phone != 'null') {
      console.log('有手机好了，可以跳转首页了2', this.phone)
      if (localStorage.getItem('logout') == 1) {
        console.log('退出状态---，等待手动登录')
      } else {
        this.$router.replace({
          name: 'home'
        })
      }
    } else {
      // 没手机号，授权,存thirdId，手机号登录
      // if (localStorage.getItem('logout') == 1) {
      //   console.log('退出状态---，等待手动登录')
      // } else {
      //   this.authGetPhone()
      // }

      this.authGetPhone()
    }

    this.initShare()
  },
  watch: {},
  methods: {
    swtchLogin() {
      this.loginType == 1 ? (this.loginType = 0) : (this.loginType = 1)
      console.log(this.loginType)
    },
    getCode() {
      if (!this.tel) {
        this.$toast('请输入手机号')
        return
      }
      if (this.isCount == true || this.isCount + '' == 'true') {
        this.$toast('请不要频繁发送')
        return
      }
      let params = { mobile: this.tel, type: 'WX_BIND_MOBILE' }
      let _that = this
      group.sendCode
        .call(_that, params)
        .then(function (res) {
          console.log('获取验证码', res)
          if (res.data.success) {
            _that.$toast('验证码发送成功')
            // 开始倒计时
            _that.isCount = true
            _that.beginCount()
          } else {
            _that.$toast(res.data.error.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 倒计时
    beginCount() {
      let i = 60
      let _that = this
      _that.codeTimer = ''
      _that.codeTimer = setInterval(function () {
        i--
        if (i <= 0) {
          _that.codeText = '获取验证码'
          _that.isCount = false
          clearInterval(_that.codeTimer)
          return
        }
        _that.codeText = i + 's后重新获取'
      }, 1000)
    },
    // 显示隐藏密码
    displayPassword() {
      this.isShowPassWord = !this.isShowPassWord

      console.log('isShowPassWord', this.isShowPassWord)
    },
    // 登录
    submit() {
      if (!this.tel) {
        this.$toast('请输入手机号')
        return
      }
      if (this.loginType == 1) {
        if (!this.verCode) {
          this.$toast('请输入验证码')
          return
        }
      } else {
        if (!this.password) {
          this.$toast('请输入密码')
          return
        }
      }
      utils.tools.showLoading('正在登录...')
      try {
        let params = ''
        if (this.loginType == 1) {
          params = { mobile: this.tel, mode: 'code', verifyCode: this.verCode }
        } else {
          params = {
            mobile: this.tel,
            mode: 'pwd',
            pwdEncrypt: utils.tools.md5(this.password)
          }
        }
        this.loginLoading = true
        let _that = this
        group.mobileLogin
          .call(_that, params)
          .then(function (res) {
            console.log('登录信息信息', res)
            utils.tools.hideLoading()
            if (res.data.success) {
              _that.token = res.data.data.token.token
              _that.user = res.data.data.user
              console.log(
                '登录成功1',
                _that.token,
                _that.user,
                _that.user.mobile
              )

              localStorage.setItem(_that.tokenKey, _that.token)
              localStorage.setItem(_that.phoneKey, _that.user.mobile)
              localStorage.setItem(_that.userKey, JSON.stringify(res.data.data.user))
              console.log('login-submit1', _that.wxThirdid, _that.user.thirdId)
              console.log('login-submit2', _that.wxThirdid, _that.user)
              // 开课校验
              _that.checkOpenClass()
            } else {
              utils.tools.hideLoading()
              _that.$toast(res.data.error.msg)
            }
            _that.loginLoading = false
          })
          .catch((error) => {
            utils.tools.hideLoading()
            _that.loginLoading = false
            _that.$toast(error.response.data.error.msg)
          })
      } catch (error) {
        this.$toast(JSON.stringify(error))
      }
    },

    authGetPhone() {
      console.log('authGetPhone---')
      if (!this.wxThirdid) {
        let code = tools.getQueryString('code') || ''
        console.log('code----')
        if (code) {
          this.wxLogin(code)
        } else {
          localStorage.setItem(this.orginUrlKey, window.location.href)
          this.strongAuth()
        }
      } else {
        // this.getInviteHistory()
        console.log('已经有wxThirdId了', this.wxThirdid, this.phone)
      }
    },
    // 开课校验
    checkOpenClass() {
      let params = { token: this.token }
      // 未绑定微信
      if (!this.user.thirdId || this.user.thirdId === '') {
        this.$router.push({
          name: 'openclass'
        })
        return;
      }
      group.openVerify
        .call(this, params)
        .then((res) => {
          console.log('开课校验信息', res)
          if (res.data.success) {
            // 无课程
            // if (!res.data.data.hasRec) {
            //   this.$router.push({
            //     name: 'empty'
            //   })
            // }
            // 有课，并且需要开课
            if (res.data.data.hasRec && res.data.data.needOpen) {
              this.$router.push({
                name: 'openclass'
              })
            } else {
              //正常的登录进来，清除掉手动退出标志
              localStorage.setItem('logout', '')
              this.$router.replace({
                name: 'home'
              })
            }
          } else {
          }
        })
        .catch((error) => {
          this.$toast(error.response.data.error.msg)
        })
    },

    forgetBtn() {
      this.$router.push({
        name: 'reset'
      })
    },
    /**
     * @description: 显示授权
     * @param {*}
     * @return {*}
     *
     */
    strongAuth() {
      let params = { redirect_uri: window.location.href }
      wx_tools.strongAuth(params)
    },

    wxLogin(code) {
      // 重新调转到处理掉code新链接
      group.wxLogin.call(this, utils.config.config.appId, code).then((res) => {
        console.log('微信登录信息-login', JSON.stringify(res))
        if (res.data.success) {
          // this.token = res.data.data.token.token
          // this.avatar = res.data.data.avatar
          // this.nickname = res.data.data.nickname
          // utils.cookie.setCookie(this.tokenKey, this.token, this.cookeTime)
          // utils.cookie.setCookie(this.avatarKey, this.avatar, this.cookeTime)
          // utils.cookie.setCookie(
          //   this.nicknameKey,
          //   this.nickname,
          //   this.cookeTime
          // )
          if (res.data.data.token) {
            localStorage.setItem(this.tokenKey, res.data.data.token.token)
          }
          if (res.data.data.user) {
            localStorage.setItem(
              this.userKey,
              JSON.stringify(res.data.data.user)
            )
          }
          localStorage.setItem(this.phoneKey, res.data.data.user.mobile)
          localStorage.setItem(this.wxThirdidKey, res.data.data.user.thirdId)
          console.log('res-wxthirdid', res.data.data.user.thirdId)

          setTimeout(() => {
            window.location.replace(localStorage.getItem(this.orginUrlKey))
          })
        } else {
          if (
            res.data.error.code == 100000 ||
            res.data.error.msg.includes('授权失败')
          )
            console.log('code已使用，重新授权')
          this.strongAuth()
        }
      })
    },
    initShare() {
      console.log('调用initShare')
      let tempJumpLink = utils.config.config.shareUrl
      // 分享字数规则：主标题两行，副标题3行，超出全部...
      let shareObj = {
        debug: false,
        referer: tempJumpLink,
        appId: utils.config.config.appId,
        title: utils.config.config.shareMainTitle,
        desc: utils.config.config.shareDesTitle,
        link: tempJumpLink,
        imgUrl: utils.config.config.shareImgUrl,
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '' // 如果type是music或video，则要提供数据链接，默认为空
        // success: this.shareSuccess
        // fail: this.shareFail
      }
      console.log('分享跳转地址--login', shareObj)
      wx_tools.initShare.call(this, shareObj)
    }
  }
}
</script>

<style src="./index.css" scoped></style>
<style scoped></style>
